import { render, staticRenderFns } from "./CoozzyAdvertisementPreviewCard.vue?vue&type=template&id=23721c65&scoped=true"
import script from "./CoozzyAdvertisementPreviewCard.vue?vue&type=script&lang=js"
export * from "./CoozzyAdvertisementPreviewCard.vue?vue&type=script&lang=js"
import style0 from "./CoozzyAdvertisementPreviewCard.vue?vue&type=style&index=0&id=23721c65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23721c65",
  null
  
)

export default component.exports